import React from 'react';
import { useSiteMetadata } from '../../hooks/useSiteMetadata';

const SEO = ({ title, description, pathname, children, language = 'en' }) => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    siteUrl,
    image,
  } = useSiteMetadata();

  const seo = {
    title: `${title} | ${defaultTitle} ` || defaultTitle,
    description: description || defaultDescription,
    url: `${siteUrl}${pathname || ``}`,
    image,
  };

  return (
    <>
      <html lang={language} />
      <title>{seo.title}</title>
      <meta name='description' content={seo.description} />
      <meta name='image' content={seo.image} />
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={seo.title} />
      <meta name='twitter:url' content={seo.url} />
      <meta name='twitter:description' content={seo.description} />
      <meta name='twitter:image' content={seo.image} />
      <meta name='twitter:creator' content={seo.twitterUsername} />
      {children}
    </>
  );
};

export default SEO;
